import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, DATE_TIME_FORMAT } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import { isEqual, cloneDeep } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import MarkupBundle from '../../../../../models/MarkupBundle';
import moment from 'moment';
import { message, Radio } from 'antd';
import BookDate from './BookDate'
import ListHotelRate from './ListHotelRate';
import './MarkupBundleDetail.less';
import Modal from "../../../common/component/Modal";

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false,
    
};

class MarkupBundleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            markupBundle: this.props.markupBundleState.detail.markupBundle,
            hotelIds: [],
            rateIds: [],
            rateSelected: [],
            typeMarkup: 'Bundle',
            isShowMsg: false
        }
    }

    componentDidMount() {
        this.initDetail()
    }


    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.type) {
            this.setState({typeMarkup: match.params.type});
        }
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getMarkupBundleDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setMarkupBundleDetail(new MarkupBundle())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.markupBundleState.detail.markupBundle && !isEqual(nextProps.markupBundleState.detail.markupBundle, this.props.markupBundleState.detail.markupBundle)) {
            if(nextProps.markupBundleState.detail.markupBundle.__data__.length > 0) {
                const markupBundleData = {
                    ...nextProps.markupBundleState.detail.markupBundle.__data__[0],
                    stayDateFrom: moment(nextProps.markupBundleState.detail.markupBundle.__data__[0].stayDateFrom),
                    stayDateTo: moment(nextProps.markupBundleState.detail.markupBundle.__data__[0].stayDateTo),
                    markupValue: nextProps.markupBundleState.detail.markupBundle.__data__[0].markupValue === 0 ? '0' : nextProps.markupBundleState.detail.markupBundle.__data__[0].markupValue,
                    markupFlightValue: nextProps.markupBundleState.detail.markupBundle.__data__[0].markupFlightValue === 0 ? '0' : nextProps.markupBundleState.detail.markupBundle.__data__[0].markupFlightValue
                };
                let hotelIds = []
                let rateIds = []
                const rateSelected = [...this.state.rateSelected]
                markupBundleData.ratePlanConfigs.forEach(item => {
                    hotelIds.push(item.hotelId)
                    item.ratePlans.forEach(rate => {
                        rateIds.push(`${item.hotelId}:${rate.ratePlanId}`)
                        rateSelected.push(`${item.hotelId}:${rate.ratePlanId}`)
                    })
                })
                this.setState({ 
                    markupBundle: markupBundleData, 
                    hotelIds,
                    rateIds,
                    rateSelected,
                    action: nextProps.markupBundleState.detail.markupBundle.__data__[0].id ? 'UPDATE' : this.state.action 
                });
            }
        }
        if(nextProps.markupBundleState.errorCode && !isEqual(nextProps.markupBundleState.errorCode, this.props.markupBundleState.errorCode)){
            if(nextProps.markupBundleState.errorCode){
                this.onDelete(JSON.parse(nextProps.markupBundleState.errorCode.message))
            }
        }
    }

    inputForm = (t, fieldName, required = false) => (
        <HMS.FormWrapperInputComponent
            isRequired={required}
            isValidation={required}
            dataValidation={this.state.markupBundle[fieldName]}
            validation={this.state.validation[fieldName]}
            labelTitle={t(`item.markupBundle.${fieldName}`)}
        >
            <Input placeholder="" type={`text`}
                className={`form-control`}
                name={fieldName} onChange={(e) => this.onChange(fieldName, e.target.value)}
                value={Func.checkUndefine(this.state.markupBundle[fieldName])} />
        </HMS.FormWrapperInputComponent>
    )

    render() {
        const { t, rateState } =  this.props;
        const { action, isSubmit, isGetItem, markupBundle, validation, hotelIds, rateSelected, typeMarkup } = this.state;
        const { isFetchingRatesByHotels, dataListRateByHotels } = rateState;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="markupBundle-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'markupBundles'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${typeMarkup === 'Hotel' ? t('item.markupBundle.titleHotel') : t('item.markupBundle.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${typeMarkup === 'Hotel' ? t('item.markupBundle.titleHotel') : t('item.markupBundle.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                            isDisableAction={isFetchingRatesByHotels}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <Wrapper className="row">
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            isRequired={'right'}
                                            isValidation={true}
                                            dataValidation={markupBundle.name}
                                            validation={validation.name}
                                            messageBelowInput={true}
                                            labelTitle={t(`item.markupBundle.name`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                disabled={action === 'UPDATE'}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                value={checkUndefine(markupBundle.name)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            isRequired={'right'}
                                            isValidation={true}
                                            dataValidation={markupBundle.stayDateFrom}
                                            validation={validation.stayDateFrom}
                                            messageBelowInput={true}
                                            labelTitle={t(`item.markupBundle.stayDate`)}
                                        >
                                            <HMS.DatePickerComponent className={`form-control applyDates w100-percent`}
                                                disabled={action === 'UPDATE'}
                                                disabledDate={this.disabledPublishDate}
                                                hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                                showTime={{ format: DATE_TIME_FORMAT.SHORT_DATE }}
                                                style={{ padding: 0, border: 0 }}
                                                onChange={(data) => this.onSelectDateRange(data, 'stayDateFrom', 'stayDateTo')} name={`applyDates`}
                                                placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                                value={[markupBundle.stayDateFrom, markupBundle.stayDateTo]}
                                                />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            labelTitle={t(`item.markupBundle.markupType`)}
                                            >
                                            <Radio.Group 
                                                disabled={action === 'UPDATE'}
                                                onChange={(e) => this.onChange('markupType', e.target.value)} 
                                                value={markupBundle.markupType} 
                                                className="radio-type-export"
                                                >
                                                <Radio.Button value={0}>Tiền mặt</Radio.Button>
                                                <Radio.Button value={1}>Phần trăm</Radio.Button>
                                            </Radio.Group>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6" />
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            isRequired={'right'}
                                            isValidation={true}
                                            dataValidation={markupBundle.markupValue}
                                            validation={validation.markupValue}
                                            messageBelowInput={true}
                                            labelTitle={t(`item.markupBundle.markupValue`)}
                                            >
                                            <Input 
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.markupBundle.markupValue")).toLowerCase()) } 
                                                type={`text`}
                                                className={`form-control`}
                                                disabled={action === 'UPDATE'}
                                                name={`markupValue`} onChange={(e) => this.onChange('markupValue', e.target.value)}
                                                value={checkUndefine(markupBundle.markupValue)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>

                                    { typeMarkup === 'Bundle' ? <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            isRequired={'right'}
                                            isValidation={true}
                                            dataValidation={markupBundle.markupFlightValue}
                                            validation={validation.markupFlightValue}
                                            messageBelowInput={true}
                                            labelTitle={t(`item.markupBundle.markupFlightValue`)}
                                            >
                                            <Input 
                                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.markupBundle.markupFlightValue")).toLowerCase()) } 
                                                type={`text`}
                                                className={`form-control`}
                                                disabled={action === 'UPDATE'}
                                                name={`markupFlightValue`} onChange={(e) => this.onChange('markupFlightValue', e.target.value)}
                                                value={markupBundle.markupFlightValue} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper> : <Wrapper className="col-md-6" />
                                        
                                    }
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            labelTitle={t(`item.markupBundle.typeOfMultipleRoom`)}
                                            isRequired={'right'}
                                        >
                                            <Radio.Group 
                                                onChange={(e) => this.onChange('typeOfMultipleRoom', e.target.value)} 
                                                value={markupBundle.typeOfMultipleRoom} 
                                                className="radio-type-export"
                                                disabled={action === 'UPDATE'}
                                            >
                                                <Radio value={"NumberOfRoom"}>Nhân theo số lượng phòng tìm kiếm</Radio>
                                                <Radio value={"NumberOfBedRoom"}>Nhân theo số lượng phòng ngủ có trong phòng tìm kiếm</Radio>
                                            </Radio.Group>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6" />
                                    <BookDate
                                        addBookDate={this.addBookDate}
                                        revertBookDate={this.revertBookDate}
                                        onDelete={this.deleteBookDate}
                                        bookDates={markupBundle.bookDates.filter(x => x.status === true) || []}
                                        inActiveBookDates={markupBundle.bookDates.filter(x => x.status === false) || []}
                                        isPercent={markupBundle.markupType === 1}
                                        disabled={action === 'UPDATE'}
                                        />
                                    <Wrapper className="w-100">
                                        <ListHotelRate 
                                            disabled={action === 'UPDATE'}
                                            hotelIds={hotelIds}
                                            rateSelected={rateSelected}
                                            onChangeHotel={this.onChangeDataHotel}
                                            typeMarkup={typeMarkup}
                                        />
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            typeInput={true}
                                            labelTitle={t(`item.markupBundle.isActived`)}
                                        >
                                            <Radio.Group 
                                                onChange={(e) => this.onChange('isActived', e.target.value)} 
                                                value={markupBundle.isActived} 
                                                className="radio-type-export"
                                                disabled={action === 'CREATE'}
                                            >
                                                <Radio value={true}>Hoạt động</Radio>
                                                <Radio value={false}>Không Hoạt động</Radio>
                                            </Radio.Group>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                </Wrapper>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    deleteBookDate = (indexDeleted, isUpdate) => {
        const markupBundle = this.state.markupBundle
        if(isUpdate){
            markupBundle.bookDates[indexDeleted].status = false;
        }
        else
        {
            let listDeleted = [...this.state.markupBundle.bookDates].filter((item, index) => indexDeleted !== index)
            markupBundle.bookDates = listDeleted
        }
        this.setState({ markupBundle: markupBundle })
    }
    onDelete = (error) => {
        const { allHotels } = this.props.hotelState;
        const { dataListRateByHotels } = this.props.rateState;
        const hotelRates = dataListRateByHotels.find(x => x.id === error.hotelId).ratePlans;
        const rates = hotelRates.filter(x => error.ratePlanIds.includes(x.refId)).map(function(elem){
            return elem.code;
        }).join(",");
        const { confirm } = Modal;
        confirm({
            title: 'Thông tin markup bị trùng lặp:',
            content: <span style={{whiteSpace: 'pre-line'}}>{`Campagin: ${error.campaignName} \n Hotel: ${allHotels.find(x => x.id === error.hotelId).name} \n Rates: ${rates}`}</span>,
            okText: 'Đóng',
            className: 'hide-button',
            closable:true,
        });
    };
    onChangeDataHotel = (key, value) => {
        this.setState({ [key]: value })
    }

    addBookDate = (item) => {
        const markupBundle = this.state.markupBundle
        markupBundle.bookDates.push(item)
        this.setState({ markupBundle })
    }
    revertBookDate = (bookDateId) => {
        const markupBundle = this.state.markupBundle
        let objIndex = markupBundle.bookDates.findIndex((obj => obj.id === bookDateId))
        markupBundle.bookDates[objIndex].status = true;
        this.setState({ markupBundle })
    }

    onSelectDateRange = (data, fieldStartDate, fieldEndDate) => {
        this.onChange(fieldStartDate, data.fullValue[0]);
        this.onChange(fieldEndDate, data.fullValue[1]);
    }

    disabledPublishDate = (current) => {
        return current && current <= moment().add(-1, 'day');
    }

    onChange = (fieldName, value) => {
        const markupBundle = this.state.markupBundle;
        markupBundle[fieldName] = value;
        this.setState({ markupBundle });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { markupBundle, action, typeMarkup } = this.state;
        if (this.validate() && this.validateList()) {
            if(parseInt(markupBundle.markupValue) < 0) {
                message.error('Giá trị không được nhập số âm');
                return;
            }
            const hotelData = this.mappingDataHotel()
            markupBundle.ratePlanConfigs = hotelData
            markupBundle.productType = typeMarkup === 'Hotel' ? 1 : 2;
            if(typeMarkup === 'Hotel'){
                markupBundle.markupFlightValue = 0;
            }
            if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createMarkupBundleDetail(markupBundle)
            } else {
                this.props.updateMarkupBundleDetail({ markupBundle: new MarkupBundle(markupBundle), props: this.props })
            }
        }
    }

    mappingDataHotel = () => {
        const { hotelIds, rateIds } = this.state;
        let dataHotelRatePlans = [];
        if(hotelIds.length > 0){
            if(rateIds.length > 0){
                dataHotelRatePlans = hotelIds.map(hotelId => {
                    const arrRateCodes = [];
                    rateIds.map(ratePS => {
                        const arrRatePlan = ratePS.split(':');
                        if (arrRatePlan && arrRatePlan.length > 0) {
                            const hotelIdRate = arrRatePlan[0];
                            const rateCode = arrRatePlan[1];
                            if (hotelIdRate === hotelId && !arrRateCodes.includes(rateCode)) {
                                arrRateCodes.push(rateCode);
                            }
                        }
                    })
                    return {
                        hotelId: hotelId,
                        ratePlans: arrRateCodes.map(id => ({
                            ratePlanId: id,
                            roomTypeIds: []
                        }))
                    }
                });
            }
        }
        return dataHotelRatePlans
    }

    validateList = () => {
        const { bookDates, rateIds, rateSelected } = this.state
        // if(bookDates && bookDates.length === 0) {
        //     message.error('Vui lòng thêm Bookdate!')
        //     return false
        // }

        if(rateIds.length === 0 && rateSelected.length === 0) {
            message.error('Vui lòng chọn rate!')
            return false
        }

        return true
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.markupBundle.name`)),
                stayDateFrom: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.markupBundle.stayDate`)),
                markupValue: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.markupBundle.markupValue`))
            }
        };
        if (this.state.typeMarkup === 'Bundle') {
            validate.required.markupFlightValue = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.markupBundle.markupFlightValue`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.markupBundle, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        this.props.history.push(PATHS.MARKUP_BUNDLE.LIST.path);
    }
}

export default MarkupBundleDetail;
